import React, { Component } from 'react'
import { Header, Segment, Button, Grid, Divider, Popup, Input,Form,Message,Search } from 'semantic-ui-react'
import { formatDate, parseDate } from 'react-day-picker/moment';
import DayPickerInput from 'react-day-picker/lib/src/DayPickerInput';

export class BulkEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            payload:undefined
        }
  }
  statusOptions = [
      {key: '0', type: 'input', text: 'Pending', value: 0},
      {key: '1', type: 'input', text: 'Scheduled', value: 1},
      {key: '2', type: 'input', text: 'Confirmed', value: 2},
      {key: '3', type: 'input', text: 'Processing', value: 3},
      {key: '4', type: 'input', text: 'Submitted', value: 4},
      {key: '5', type: 'input', text: 'Completed', value: 5},
      {key: '6', type: 'input', text: 'Cancelled', value: 6 },
      {key: '7', type: 'input', text: 'Aborted', value: 7 },
    ]
  renderBulkEdit = () => {
    switch (this.props.type) {
      case "company":
      return( <Form.Field>{this.props.arrayIndex == undefined || this.props.showDetails ? <label>Company</label> : null}
      <Search
        loading={this.props.companyOptions.length == 0}
        placeholder='Search...'
        results={this.props.companyOptions.filter(company =>{return company.title.toLowerCase().includes(this.state.payload? this.state.payload.toLowerCase():"")})}
        value={this.props.visitCompany} 
        onSearchChange={(e,data) => { this.setState({ payload: data.value })}} 
        onResultSelect={(e,data) => { this.setState({ payload: data.result.title })}} 
        />
     </Form.Field>)
      case "time":
        return (
          <Input
            placeholder="Bulk Edit"
            onChange={(e) => {
              this.setState({ payload: e.target.value });
            }}
          />
        );

        case "branch":
        return (
          <Input
            placeholder="Bulk Edit"
            onChange={(e) => {
              this.setState({ payload: e.target.value });
            }}
          />
        );
        case "notes":
          return (
            <Input
              placeholder="Bulk Edit"
              onChange={(e) => {
                this.setState({ payload: e.target.value });
              }}
            />
          );
      case "date":
        return (
          <Form.Field>
            <DayPickerInput
              placeholder="DD-MM-YYYY"
              dayPickerProps={{
                todayButton: "Clear",
                firstDayOfWeek: 1,
                onTodayButtonClick: (e) => {
                  this.setState({ payload: undefined });
                },
              }}
              format="DD-MM-YYYY"
              formatDate={formatDate}
              parseDate={parseDate}
              value={this.state.payload}
              onDayChange={(day) => {
                if (day) {
                  this.setState({ payload: day });
                } else {
                  this.setState({ payload: undefined });
                }
              }}
            />
          </Form.Field>
        );
      case "clerk":
        return (
          <Form.Dropdown
            options={this.props.clerkOptions}
            search
            selection
            fluid
            deburr
            placeholder="Select Clerk"
            defaultValue={0}
            onChange={(e, option) => {
              this.setState({ payload: option.value });
            }}
          />
        );
      case "status":
        return (<React.Fragment>
          <Form.Dropdown
            options={this.statusOptions}
            search
            selection
            fluid
            deburr
            placeholder="Select Status"
            defaultValue={0}
            onChange={(e, option) => {
              this.setState({ payload: option.value });
            }}
          />
          <Message size='mini'>PVs with "Cancelled" status will not be changed</Message></React.Fragment>
        );
    }
  };
    render() {
    return (
      <Popup
        on="click"
        position="bottom left"
        flowing
        wide="very"
        size="large"
        trigger={<Button compact> {this.props.headerTitle}</Button>}
      >
        <Header>Bulk Editing {this.props.headerTitle}</Header>
        <div style={{textAlign:"center"}}>
                <div style={{marginBottom:"1rem"}}>{this.renderBulkEdit()}</div>
          <Button compact
            content="Confirm"
            onClick={() => {
              this.props.bulkEditFunction(this.props.type, this.state.payload);
            }}
          />
        </div>
      </Popup>
    );
  }
}

export default BulkEdit


// WEBPACK FOOTER //
// ./src/views/property_visits/bulk_edit.js